import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../pages/Home.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../pages/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../pages/Contact.vue')
  },
  {
    path: '/doatahlil',
    name: 'doatahlil',
    component: () => import(/* webpackChunkName: "doatahlil" */ '../pages/Doatahlil.vue')
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import(/* webpackChunkName: "setting" */ '../pages/Setting.vue')
  },
  {
    path: '/tahlil',
    name: 'tahlil',
    component: () => import(/* webpackChunkName: "tahlil" */ '../pages/Tahlil.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import(/* webpackChunkName: "team" */ '../pages/Team.vue')
  },
  {
    path: '/surat/:namasurat',
    name: 'surat',
    component: () => import(/* webpackChunkName: "yasin" */ '../pages/Surat.vue'),
    params: true
  },
  {
    path: '/doa/:namadoa',
    name: 'doa',
    component: () => import(/* webpackChunkName: "yasin" */ '../pages/Doa.vue'),
    params: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition){
      return savedPosition;
    }else if(to.hash){
      selector: to.hash;
    }
  }
})

export default router
